import {API_DRIVER} from "../configs/axios";

export const EventLogsService = {
    fetchEventsData: (integrationId, page, size, sortBy, sortOrder, ruleType,
                      msisdn, ruleName, serviceType, startDate, endDate) => {
        return API_DRIVER.get(`/api/event-logs`, {
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                ruleType: ruleType.length ? ruleType : null,
                msisdn: msisdn.length ? msisdn : null,
                ruleName: ruleName.length ? ruleName : null,
                serviceType: serviceType.length ? serviceType : null,
                startDate,
                endDate
            }
        })
    },
    fetchEventDetailsData: (integrationId, eventLogId) => {
        return API_DRIVER.get(`/api/event-logs/details/${eventLogId}`, {
            params: {
                integrationId
            }
        })
    },
    downloadCsv: (selectedEventLogs, areAllSelected, integrationId, sortBy, sortOrder, ruleType,
                  msisdn, ruleName, serviceType, startDate, endDate) => {
        const body = {
            selectedEventLogs,
            integrationId,
            sortBy,
            sortOrder,
            ...(ruleType.length ? {ruleType} : {}),
            ...(msisdn.length ? {msisdn} : {}),
            ...(ruleName.length ? {ruleName} : {}),
            ...(serviceType.length ? {serviceType} : {}),
            startDate,
            endDate,
            areAllSelected
        }

        return API_DRIVER.post(`/api/event-logs/download-csv`, body, {
            responseType: 'blob'
        })
    }
}
